import React, { Component } from 'react'
import Meta from 'components/layout/Meta';
import {actions} from "components/page/pageModule";

import './index.scss'

class LuoWang extends Component {

  constructor(props) {
    super(props)
  }

  render() {

    return (
      <div className="servicesWrap">
        <Meta location={this.props.location} title=""/>
        <div className="banner fa_banner">
          <div className="banner_cont">
            <h1>反欺诈系统-罗网</h1>
            <p>反欺诈平台罗网致力于解决各类欺诈风险问题，通过反欺诈规则对用户行为或提交的资料进行欺诈判定和决策，同时预警潜在客户的欺诈风险。罗网适用于多种场景，业务专家可以根据业务需要，如申请反欺诈、反褥羊毛等，在罗网自主配置规则。</p>
            <a href="./services/submitform">方案咨询</a>
          </div>
        </div>
        <div className="wrapPanel">
          <div className="panel lw_panel">
            <h2><span>反欺诈全流程支持</span></h2>
            <img src={require('./images/pro_6.png')}/>
          </div>
        </div>
        <div className="wrapPanel panelCol">
          <ul className="panel_ul_lw">
            <li>
              <h2><span>知识图谱</span></h2>
              <p>知识图谱把不同来源的数据整合在一起，组成一个关系网络。反欺诈引擎从关系的角度通过不一致性校验、异常分析有效地识别出欺诈案件，如身份造假，团体欺诈，代办包装等</p>
            </li>
            <li>
              <img src={require('./images/pro_7.png')}/>
            </li>
            <li>
              <img src={require('./images/pro_8.png')}/>
            </li>
          </ul>
        </div>
        <div className="wrapPanel fa_wrap">
          <div className="panel apply_panel">
            <h2><span>应用场景</span></h2>
            <ul className="apply_ul">
              <li>
                <img src={require('./images/pro_9.png')}/>
                <p>申请反欺诈</p>
              </li>
              <li>
                <img src={require('./images/pro_10.png')}/>
                <p>交易反欺诈</p>
              </li>
              <li>
                <img src={require('./images/pro_11.png')}/>
                <p>图案欺诈</p>
              </li>
            </ul>
          </div>
        </div>
        <div className="wrapPanel panelCol">
          <div className="panel pro_panel_wl">
            <h2><span>产品优势</span></h2>
            <ul className="pro_ul">
              <li>
                <img src={require('./images/icon_5.png')}/>
                <p className="title">规则灵活配置</p>
                <p>业务人员可以自主配置不同场景的规则，如申请法反欺诈、交易反欺诈，也可配置规则自动判定的结果，不依赖技术人员</p>
              </li>
              <li>
                <img src={require('./images/icon_6.png')}/>
                <p className="title">机器学习反哺专家</p>
                <p>基于数据输出有解释性的特征反哺专家，专家经验和人工智能相互协同、持续优化</p>
              </li>
              <li>
                <img src={require('./images/icon_7.png')}/>
                <p className="title">名单自动转化</p>
                <p>支持多种名单以及提供名单自动转化的API接口，如白名单、欺诈名单、排除名单等，方便名单及时生效</p>
              </li>
            </ul>
            <ul className="pro_ul">
              <li>
                <img src={require('./images/icon_5.png')}/>
                <p className="title">匹配高效、风险直观</p>
                <p>知识图谱支持实时大并发，海量数据下快速匹配；图网络的可视化展示更直观地辅助排疑人员挖掘欺诈风险</p>
              </li>
              <li>
                <img src={require('./images/icon_6.png')}/>
                <p className="title">存量数据迅捷迁移</p>
                <p>提供便捷的存量数据迁移方案，可协助迁移，也可业务自助迁移</p>
              </li>
              <li>
                <img src={require('./images/icon_7.png')}/>
                <p className="title">名单自动转化</p>
                <p>产品部署在客户本地机器，数据只在内网流转，避免数据外泄</p>
              </li>
            </ul>
          </div>
        </div>

      </div>
    )
  }
}


export default LuoWang



// WEBPACK FOOTER //
// ./modules/services/LuoWang.js